// frontend/src/services/leaderboard.service.ts

import { authService } from './auth.service';
import { LeaderboardEntry, LeaderboardScope } from '../types/leaderboard.types';
import { queryCache, CACHE_TTL } from '../lib/queryCache';

const API_BASE = (import.meta.env.PROD && (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)) ? '' : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080');

class LeaderboardApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LeaderboardApiError';
  }
}

export const leaderboardService = {
  async getLeaderboard(scope: LeaderboardScope = 'all'): Promise<LeaderboardEntry[]> {
    return queryCache.dedupe(`leaderboard:${scope}`, async () => {
      const token = await authService.getAccessToken();
      if (!token) throw new LeaderboardApiError('Oturum bulunamadı, lütfen giriş yapın.');

      const res = await fetch(`${API_BASE}/api/leaderboard?scope=${scope}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      if (!res.ok) throw new LeaderboardApiError(data?.error?.message || 'Liderlik tablosu alınamadı.');
      return data.leaderboard;
    }, CACHE_TTL.LEADERBOARD);
  },
};

export { LeaderboardApiError };
